import { makeStyles } from '@material-ui/core';
import { vh } from 'src/common/helpers/dimension-helper';

export const styles = makeStyles({
  vatScreen: {
    width: '100%',
    alignContent: 'flex-end',
    padding: `1.3vh 0`,
  },
  buttonStyles: {
    fontSize: vh(2.1248),
    marginRight: '1.3280vh',
  },
});
